var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "palette") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-304",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "palette",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,40.0037973 L2,8.0042577 C2,4.6890094 4.68344685,2 7.99620271,2 L16.0037973,2 C19.3173115,2 22,4.68636176 22,8.0042577 L22,11.7430014 L25.3229215,8.42007996 C27.6677598,6.07524167 31.4697686,6.06991294 33.810683,8.41082725 L39.5891727,14.189317 C41.9317163,16.5318606 41.9259054,20.3310932 39.57992,22.6770785 L36.2569986,26 L39.9999745,26 C43.3133579,26 46,28.6839211 46,31.9962027 L46,40.0037973 C46,43.3143527 43.3092061,46 39.9999745,46 L8.00002553,46 C4.68664207,46 2,43.3160789 2,40.0037973 Z M18,15.7430014 L18,8.0042577 C18,6.89427646 17.1069464,6 16.0037973,6 L7.99620271,6 C6.8944422,6 6,6.8962963 6,8.0042577 L6,27.7884869 C6.13051733,27.6278964 6.27054469,27.4724568 6.42007996,27.3229215 L18,15.7430014 L18,15.7430014 Z M13.3998557,26 L13.3998557,26 L30.6001443,26 L36.7514929,19.8486514 C37.5373147,19.0628296 37.5392519,17.7962504 36.7607456,17.0177442 L30.9822558,11.2392544 C30.2052163,10.4622148 28.9358618,10.4639939 28.1513486,11.2485071 L13.3998557,26 Z M6,31.9962027 L6,40.0037973 C6,41.1060321 6.89487425,42 8.00002553,42 L39.9999745,42 C41.1017796,42 42,41.1034976 42,40.0037973 L42,31.9962027 C42,30.8939679 41.1051257,30 39.9999745,30 L8.00002553,30 C6.8982204,30 6,30.8965024 6,31.9962027 Z M12,39 C10.3431458,39 9,37.6568542 9,36 C9,34.3431458 10.3431458,33 12,33 C13.6568542,33 15,34.3431458 15,36 C15,37.6568542 13.6568542,39 12,39 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.f93151e47be62b46ab92078409eddf61.svg";
export { ForwardRef as ReactComponent };